/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const LoadingContext = React.createContext({});

export const LoadingProvider = ({ children }) => {
  const navigate = useNavigate();

  const [stack, setStack] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMensagem, setLoadingMensagem] = useState('');
  const [loadingBtn, setLoadingBtn] = useState('');
  const [loadingAction, setLoadingAction] = useState(null);

  const loadingStack = (url: string, method: string, callback) => {
    setStack([...stack, url]);

    Promise.all(stack).then((e) => {
      console.log(e);
    });
  };

  const setClearLoading = () => {
    setLoading(false);
    setLoadingBtn('');
    setLoadingMensagem('');
    setLoadingAction(null);
  };

  return (
    <LoadingContext.Provider
      value={{
        loading,
        setLoading,
        loadingMensagem,
        setLoadingMensagem,
        loadingBtn,
        setLoadingBtn,
        loadingAction,
        setLoadingAction,
        setClearLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
